import React, { Component } from 'react'
import { TextField } from '@mui/material'
import FieldWrapper from '../FieldRowWrapper'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import RawHtml from 'stories/components/RawHtml'

import './web-site-input.css'

export default class WebsiteInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputChange = (event) => {
    const { value } = event.target
    if (value.length <= 4 && value !== 'http') {
      this.props.onChange('')
    } else {
      this.props.onChange(value)
    }
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    const { value = '' } = this.props
    return value === '' ? 'https://' : value
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder = '',
      required,
      touched,
      error,
      description,
      customized,
      disabled,
      helperText,
    } = this.props

    const classNames = {
      'formz-web-site-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      type: 'text',
      name,
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      disabled,
    }
    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>

            <RawHtml
              className="formz-field-description"
              content={description}
            />
            <input
              {...inputProps}
              className="formz-input-field ltr"
              placeholder={placeholder}
            />
          </label>
        </FieldRowWrapper>
      )
    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField
          {...inputProps}
          label={label || placeholder}
          error={Boolean(error)}
          style={{ direction: 'ltr' }}
          helperText={helperText}
        />
      </FieldWrapper>
    )
  }
}
